import { REQUEST_ENTITY } from '../../../../constants/entity'
import { EntityLink } from '../../../Entity'
import { FloatingTooltip } from '../../../Floating'
import { TableCellBase } from '../TableCellBase'
import { TableEmptyCell } from '../TableEmptyCell'

import * as styles from './TableRequestNoCell.module.css'

function TableRequestNoCell({ id, linkTo, unread, value, ...cellProps }) {
  return value ? (
    <TableCellBase {...cellProps}>
      <FloatingTooltip content={value}>
        <div className={styles.container}>
          <EntityLink
            entity={REQUEST_ENTITY}
            id={id}
            text={value}
            to={linkTo}
            unread={unread}
          />
        </div>
      </FloatingTooltip>
    </TableCellBase>
  ) : (
    <TableEmptyCell {...cellProps} />
  )
}

export default TableRequestNoCell
